import { StreamDataHandlers } from 'streamsState/StreamDataService';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';
import { Store } from 'redux';
import { HistPriceVolElement } from 'widgets/historicalPercentageChange/api/HistPriceVolElement.ts';
import { createReceiveMessageAction } from 'streamsState/store/streamedData/actions.ts';
import { Logger } from '@instinet-analytics/core-lib';

export function getHistPriceVolMessageHandler(
    store: Store,
    logger: Logger
): StreamDataHandlers<HistPriceVolElement> {
    return {
        onMessage: (streamKey: string, message: HistPriceVolElement) => {
            store.dispatch(
                createReceiveMessageAction(
                    'startHistPriceVolStream',
                    streamKey,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    message as any
                )
            );
        },
        onError: (streamKey: string, error: StreamError) => {
            logger.critical('Error in startHistPriceVolStream stream', {
                streamKey,
                error,
            });
        },
    };
}
